import { render, staticRenderFns } from "./Responsable.vue?vue&type=template&id=4473e26c"
import script from "./Responsable.vue?vue&type=script&lang=js"
export * from "./Responsable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4473e26c')) {
      api.createRecord('4473e26c', component.options)
    } else {
      api.reload('4473e26c', component.options)
    }
    module.hot.accept("./Responsable.vue?vue&type=template&id=4473e26c", function () {
      api.rerender('4473e26c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Responsable.vue"
export default component.exports